const smartbooksShopfront = {
  projectId: 'smartbooks365-production',
  storeIds: {
    finglas: 'boxx-finglas'
  }
};

const development = {
  environment: 'development',
  development: true,
  smartbooksShopfront,
  stripePublicKey: 'pk_test_OBNDcKxnnOAzyO4JKcB2mRb200Bv691PIc',
  cloudFunctionsURL:
    'https://us-central1-boxx-testbed.cloudfunctions.net/functions',
  firebase: {
    apiKey: 'AIzaSyCO3UhYk7c5jW_cv1Zj1l0vYixpntA99QM',
    authDomain: 'boxx-testbed.firebaseapp.com',
    databaseURL: 'https://boxx-testbed.firebaseio.com',
    projectId: 'boxx-testbed',
    storageBucket: 'boxx-testbed.appspot.com',
    messagingSenderId: '559981085995',
    appId: '1:559981085995:web:9b03f87d01d6f7aa00b16e'
  }
};

const production = {
  environment: 'production',
  production: true,
  smartbooksShopfront,
  stripePublicKey: 'pk_live_XqUjlAckXvWhxZHid4UMnqyL00l1L64Os7',
  cloudFunctionsURL:
    'https://us-central1-boxx-production.cloudfunctions.net/functions',
  firebase: {
    apiKey: 'AIzaSyDYuXtYC87GeBOVYJk6UcJu_ish15kKy6o',
    authDomain: 'boxx-production.firebaseapp.com',
    databaseURL: 'https://boxx-production.firebaseio.com',
    projectId: 'boxx-production',
    storageBucket: 'boxx-production.appspot.com',
    messagingSenderId: '727815584328',
    appId: '1:727815584328:web:02dd5a32e18d5a2265367d'
  }
};

export default process.env.NODE_ENV === 'production' ? production : development;
